import { useEffect, useState } from 'react';

import { decryptEmail, trackContact } from './api';

const { searchParams } = new URL(window.location.href);
const encryptedEmail = searchParams.get('ee');

export default () => {
	const [isDecryptingEmail, setIsDecryptingEmail] = useState(!!encryptedEmail);
	const [decryptedEmail, setDecryptedEmail] = useState('');
	const [decryptionError, setDecryptionError] = useState('');

	useEffect(() => {
		const validateUsername = async username => {
			try {
				const validation = await decryptEmail(username);
				setDecryptedEmail(validation.username);
				if (!validation.is_available) {
					setDecryptionError(validation.reason);
				} else {
					trackContact({
						email: validation.username,
					});
				}
			} catch (err) {
				if (err.username) {
					setDecryptedEmail(err.username);
					setDecryptionError('invalid');
				}
			} finally {
				setIsDecryptingEmail(false);
			}
		};
		if (encryptedEmail) {
			validateUsername(encryptedEmail);
		}
	}, []);

	return { isDecryptingEmail, decryptedEmail, decryptionError };
};
